'use strict';
import angular from 'angular';
import _ from 'lodash';
import $ from "jquery";

angular.module('association.history.ctrls', [])
    .controller('AssociationHistoryController', AssociationHistoryController)
    .controller('PlacementManagerController', PlacementManagerController);

AssociationHistoryController.$inject = ['$scope', '$modal', '$ioAlert', '$confirm', 'AssociationHistoryService', '$state', '$stateParams', '$rootScope', 'filterFilter', '$timeout'];

function AssociationHistoryController($scope, $modal, $ioAlert, $confirm, AssociationHistoryService, $state, $stateParams, $rs, filterFilter, $timeout) {
    $scope.fromPage = undefined;   // 'order', 'lineitem', or 'flight'.
    $scope.id = undefined;         // Can be order id, line item id, or flight id, depending on fromPage.
    $scope.lineItemId = undefined; // Only used if the fromPage is flight, to know where to go back (in this case we need both line item id and flight id).
    $scope.associationHistoryData = undefined;
    $scope.historyLoaded = false;

    let getAssociationHistory = function() {
        $rs.loadingInProgress = true;
        $scope.historyLoaded = false;
        $rs.loadertitle = "Fetching association history data...";
        if ($scope.fromPage == 'order') {
            AssociationHistoryService.getAssociationHistoryForOrder($scope.id).then(handleAssociationHistoryResults, handleAssociationHistoryError);
        } else if ($scope.fromPage == 'lineitem') {
            AssociationHistoryService.getAssociationHistoryForLineItem($scope.id).then(handleAssociationHistoryResults, handleAssociationHistoryError);
        } else if ($scope.fromPage == 'flight') {
            AssociationHistoryService.getAssociationHistoryForFlight($scope.id).then(handleAssociationHistoryResults, handleAssociationHistoryError);
        }
    };

    let handleAssociationHistoryResults = function(data) {
        $rs.loadingInProgress = false;
        if (data.errors) {
            for (let x = 0; x < data.errors.length; x++) {
                console.log(data.errors[x]);
                $ioAlert.show("Error", data.errors[x], "error");
            }
        } else {
            $scope.associationHistoryData = data.associationHistory;
            // We want the data initially sorted by flight_id, and then association_started_at (i.e. in chronological
            // order, but grouped by flight_id).  It's as if we clicked (on the page) on the association_started_at
            // column, then the flight_id column.
            $scope.associationHistoryData = _.sortBy($scope.associationHistoryData, 'association_started_at');
            $scope.associationHistoryData = _.sortBy($scope.associationHistoryData, 'flight_id');
            $scope.historyLoaded = true;
            setDataTableOptions();
        }
    }

    let handleAssociationHistoryError = function() {
        $rs.loadingInProgress = false;
        $ioAlert.show('Error!', 'Something went wrong here. Please refresh the page to try again.', 'error');
    };

    $scope.backToFromPage = function() {
        if ($scope.fromPage == 'order') {
            $state.go('viewOrder', {
                id: $scope.id
            });
        } else if ($scope.fromPage == 'lineitem') {
            $state.go('viewLineItem', {
                lineItemId: $scope.id
            });
        } else if ($scope.fromPage == 'flight') {
            $state.go('viewLineItem', {
                lineItemId: $scope.lineItemId,
                flightId: $scope.id
            });
        }
    };

    $scope.showDeleteConfirm = function(association) {
        $confirm.open({
            size: 'sm',
            text: 'Are you sure you want to delete this association?'
        }).then(function() {
            deleteAssociation(association);
        }, function() {});
    };

    let deleteAssociation = function(association) {
        AssociationHistoryService.deleteAssociationHistoryEntry(association.id).then(function(data) {
            if (data.errors) {
                for (let x = 0; x < data.errors.length; x++) {
                    console.log(data.errors[x]);
                    $ioAlert.show("Error", data.errors[x], "error");
                }
            } else {
                $ioAlert.show('Success', 'Association history entry ' + association.id + ' deleted.', 'success');
                // Reload the data now that we have one less entry.  Simpler than tinkering with the already loaded data...
                getAssociationHistory();
            }
        }, handleAssociationHistoryError);
    };

    let setDataTableOptions = function() {
        $timeout(function() {
            let options = $.core.datatable.defaultOptions('association');
            options.iActions = 1;
            options.hasFixedHeader = false;
            options.isIoTool = true;
            $.core.datatable.build($('#associationHistory-table'), options);
        });
    };

    const init = function() {
        $scope.fromPage = $stateParams.fromPage;
        $scope.id = $stateParams.id;
        $scope.lineItemId = $stateParams.lineItemId;

        if (!$scope.fromPage) {
            $ioAlert.show('Association History', 'FromPage input parameter not set', 'error');
        }

        if (!$scope.id) {
            $ioAlert.show('Association History', 'id input parameter not set', 'error');
        }

        if (!$scope.fromPage || !$scope.id) {
            return;
        }

        getAssociationHistory();
    };

    init();
}

PlacementManagerController.$inject = ['$scope', '$modal', '$ioAlert', '$confirm', 'AssociationHistoryService',
    'OrdersService', '$state', '$stateParams', '$rootScope', 'filterFilter', '$timeout', 'ModalService',
    'WorkflowsService'];

function PlacementManagerController($scope, $modal, $ioAlert, $confirm, AssociationHistoryService, OrdersService, $state,
                                    $stateParams, $rs, filterFilter, $timeout, ModalService, WorkflowsService) {
    const LineItemArchivedStatusIds = [13,14,32]; // Integers, so careful with incoming string values
    const FlightArchivedStatusNames = {
        STATUS_NAME_FLIGHT_COMPLETE: 'Complete',
        STATUS_NAME_FLIGHT_CLOSED: 'Closed',
        STATUS_NAME_FLIGHT_CANCELLED: 'Cancelled'
    };
    let FlightArchivedStatusIds = [];

    $scope.fromPage = undefined;   // 'order', 'orderDetails' or none (if clicked from the left menu).
    $scope.orderId = undefined;
    $scope.order = undefined;
    $scope.showAllItems = true;
    $scope.products = [];
    $scope.productId = undefined;
    $scope.hideProductSelection = true;
    $scope.lineItemSelected = false;
    $scope.someLineItemsSelected = false;
    $scope.allLineItemsSelected = false;
    $scope.someAssociationsSelected = false;
    $scope.allAssociationsSelected = false;
    $scope.workflowActions = undefined;
    $scope.flightStatusList = undefined;
    $scope.associations = [];
    $scope.lineItems = [];
    $scope.targetLineItems = [];
    $scope.lineItemsWithCurrentAssociations = new Set();
    $scope.lineItemsWithHistoricalAssociations = new Set();
    $scope.lineItemsWithCurrentOpenAssociations = new Set();
    $scope.lineItemsWithHistoricalOpenAssociations = new Set();
    $scope.formObj = {};

    const getOrder = function() {
        OrdersService.getOrder($scope.orderId).then(function() {
            $scope.order = OrdersService.order;
            getPlacementProducts();
        }, function() {
            console.log("Error getting order for id: " + $scope.orderId);
        });
    }

    const getPlacementProducts = function() {
        OrdersService.getOrderPlacementProducts($scope.orderId).then(function(products) {
            $scope.products = products;
            // Check if a specific line item was passed to this page
            if ($scope.lineItemId && $scope.order.hasOwnProperty('lineItems')) {
                const lineItem = _.find($scope.order.lineItems, {id: $scope.lineItemId});
                if (lineItem) {
                    // We select the passed line item's product, but we still allow the user to change products
                    // if there are more than 1.
                    $scope.selectProduct(lineItem.product_id);
                    $scope.hideProductSelection = ($scope.products.length === 1);
                    return;
                }
            }
            // If there's only one product, there's no point showing the product selector, so handle that case.
            if ($scope.products.length === 1) {
                $scope.hideProductSelection = true;
                $scope.productId = $scope.products[0].id;
                getLineItemAndAssociationData($scope.orderId, $scope.productId);
            } else {
                $scope.hideProductSelection = false;
            }
        }, function() {
            console.log("Error getting placement products for orderId: " + $scope.orderId);
        });
    }

    $scope.selectProduct = function(productId) {
        $scope.productId = productId;
        resetDataTables(); // Only useful if changing product, but doesn't hurt for the 1st one.
        getLineItemAndAssociationData($scope.orderId, $scope.productId);
    }

    const getLineItemAndAssociationData = function(orderId, productId) {
        if (!orderId || !productId) {
            return;
        }
        $rs.loadingInProgress = true;
        $rs.loadertitle = "Fetching Flight Placement Information";
        $scope.lineItemsReceived = false;
        $scope.associationDataReceived = false;
        $scope.lineItemSelected = false;
        $scope.someLineItemsSelected = false;
        $scope.allLineItemsSelected = false;
        $scope.someAssociationsSelected = false;
        $scope.allAssociationsSelected = false;
        $scope.currentLineItemId = undefined;
        $scope.allAssociations = [];
        $scope.associations = []; // For the selected line item
        $scope.lineItems = [];
        $scope.targetLineItems = [];
        $scope.lineItemsWithCurrentAssociations.clear();
        $scope.lineItemsWithHistoricalAssociations.clear();
        $scope.lineItemsWithCurrentOpenAssociations.clear();
        $scope.lineItemsWithHistoricalOpenAssociations.clear();
        $scope.formObj.targetLineItemId = undefined;

        // Fetch association data and line items in parallel.

        OrdersService.getPlacementDataForOrderAndProduct(orderId, productId).then(function(associations) {
            associations.current_associations.forEach(function(item) {
                item.isCurrent = true;
                $scope.allAssociations.push(item);
                $scope.lineItemsWithCurrentAssociations.add(item.line_item_id);
                if (!isArchivedFlightStatusId(item.flight_status_id)) {
                    $scope.lineItemsWithCurrentOpenAssociations.add(item.line_item_id);
                }
            });
            associations.historical_associations.forEach(function(item) {
                item.isHistorical = true;
                $scope.allAssociations.push(item);
                $scope.lineItemsWithHistoricalAssociations.add(item.line_item_id);
                if (!isArchivedFlightStatusId(item.flight_status_id)) {
                    $scope.lineItemsWithHistoricalOpenAssociations.add(item.line_item_id);
                }
            });
            $scope.associationDataReceived = true;
            verifyLoadingCompleted();
        }, function() {
            $scope.associationDataReceived = true;
            console.log('Error getting line item and flight association data for order id: ' + orderId + ' and product id: ' + productId);
            $ioAlert.show('Placement management', 'Error fetching line item and flight association data', 'error');
            verifyLoadingCompleted();
        });

        OrdersService.getLineItemDataForOrderAndProduct(orderId, productId).then(function(lineItems) {
            $scope.allLineItems = lineItems;
            $scope.lineItemsReceived = true;
            $scope.openLineItems = [];
            $scope.allLineItems.forEach(function (lineItem) {
                if (!isArchivedLineItemStatusId(lineItem.line_item_status_id)) {
                    $scope.openLineItems.push(lineItem);
                }
            });
            verifyLoadingCompleted();
        }, function() {
            $scope.lineItemsReceived = true;
            console.log('Error getting line items for order id: ' + orderId + ' and product id: ' + productId);
            $ioAlert.show('Placement management', 'Error fetching line items', 'error');
            verifyLoadingCompleted();
        });
    }

    const verifyLoadingCompleted = function() {
        if ($scope.associationDataReceived && $scope.lineItemsReceived) {
            $scope.lineItems = $scope.showAllItems ? _.cloneDeep($scope.allLineItems) : _.cloneDeep($scope.openLineItems);
            $scope.targetLineItems = $scope.showAllItems ? _.cloneDeep($scope.allLineItems) : _.cloneDeep($scope.openLineItems);
            $scope.lineItems.forEach(function(lineItem) {
                if ($scope.showAllItems) {
                    lineItem.hasCurrentAssociations = $scope.lineItemsWithCurrentAssociations.has(lineItem.line_item_id);
                    lineItem.hasHistoricalAssociations = $scope.lineItemsWithHistoricalAssociations.has(lineItem.line_item_id);
                } else {
                    lineItem.hasCurrentAssociations = $scope.lineItemsWithCurrentOpenAssociations.has(lineItem.line_item_id);
                    lineItem.hasHistoricalAssociations = $scope.lineItemsWithHistoricalOpenAssociations.has(lineItem.line_item_id);
                }
            });
            setLineItemDataTableOptions();
            $rs.loadingInProgress = false;
            // Now that we've loaded the important and urgent data, get workflow actions in the
            // background, in case the user decides to move flights (the option to choose a flight status and use a
            // flight workflow action will be offered).
            if (!$scope.workflowActions) {
                getWorkflowActions();
            }

            // If the line item was passed to this page, immediately select it.
            if ($scope.lineItemId) {
                const selectedLineItem = _.find($scope.lineItems, {line_item_id: $scope.lineItemId});
                if (selectedLineItem) {
                    $scope.viewFlights(selectedLineItem);
                }
            }
        }
    }

    const setLineItemDataTableOptions = function() {
        $timeout(function() {
            let options = $.core.datatable.defaultOptions('line item');
            options.hasFixedHeader = false;
            options.isIoTool = true;
            // There's only 1 non-sortable column, so we can just use _.find to find a single one.
            options.nonSortableColumnIndex = $('#placementLineItems-table').find('th.non-sortable').index();
            $.core.datatable.build($('#placementLineItems-table'), options);
        });
    }

    const setAssociationDataTableOptions = function() {
        $timeout(function() {
            let options = $.core.datatable.defaultOptions('association');
            options.hasFixedHeader = false;
            options.isIoTool = true;
            options.nonSortableColumnIndex = $('#placementAssociations-table').find('th.non-sortable').index();
            $.core.datatable.build($('#placementAssociations-table'), options);
        });
    }

    const clearFlightCheckboxes = function() {
        // Clear any previous checkboxes for the associations that were previously there.
        $scope.someAssociationsSelected = false;
        $scope.allAssociationsSelected = false;
        _.each($scope.associations, function (association) {
            association.checked = false;
        });
        $scope.associations = []; // For the selected line item
    }

    $scope.viewFlights = function(lineItem) {
        if ($scope.currentLineItemId === lineItem.line_item_id) {
            return;  // No change, ignore.
        }
        clearFlightCheckboxes();
        resetAssociationsDataTable(); // We're rebuilding that table so clear its internal structures.

        if ($scope.currentLineItemId && $scope.allLineItemsSelected) {
            // If all line items were checked, and we are choosing a new selected line item, re-check the
            // previously selected line item.
            const previousLineItem = _.find($scope.lineItems, {line_item_id: $scope.currentLineItemId});
            if (previousLineItem) {
                previousLineItem.checked = true;
            }
        }
        $scope.currentLineItemId = lineItem.line_item_id;
        $scope.allAssociations.forEach(function(association) {
            if (association.line_item_id === lineItem.line_item_id) {
                if ($scope.showAllItems || !isArchivedFlightStatusId(association.flight_status_id)) {
                    $scope.associations.push(association);
                }
            }
        });
        $scope.lineItemSelected = true;
        lineItem.checked = false; // Cannot assign flights to their currently associated line item, so disable the checkbox and uncheck it.
        if ($scope.associations.length > 0) {
            setAssociationDataTableOptions();
        }
        let allUnchecked = true;
        _.each($scope.lineItems, function(item) {
            if (item.checked) {
                allUnchecked = false;
            }
        });
        if (allUnchecked) {
            $scope.someLineItemsSelected = false;
            // Do not set allLineItemsSelected to false, so that if we later select another one, we re-check this one.
        }
        // Remove the selected line item from the possible move targets, since we don't want to move flights to their
        // current line item (this would be a NOOP)!
        $scope.targetLineItems = _.clone($scope.lineItems);  // shallow clone
        const currentLineItemIndex = _.findIndex($scope.lineItems, {line_item_id: $scope.currentLineItemId});
        if (currentLineItemIndex >= 0) {
            $scope.targetLineItems.splice(currentLineItemIndex, 1);
        }
        if ($scope.formObj.targetLineItemId === $scope.currentLineItemId) {
            $scope.formObj.targetLineItemId = undefined; // Make sure to clear if it was already selected.
        }
    }

    // handle unchecked and checked lineItems when doing search
    angular.element(document).ready(function () {
        angular.element('body').on('search.dt', function() {
            const table = $('#placementLineItems-table').DataTable();
            // traverse the visible lineItems and get lineItem id array
            let visibleLineItemIds = [];
            table.rows({filter: 'applied'}).every(function () {
                const data = this.data();
                const line_item_id = $(data[1]).html();
                visibleLineItemIds.push(line_item_id);
            });
            // check and uncheck lineItems according to visible lineItem id array
            // excluding current lineItem
            _.each($scope.lineItems, function (lineItem) {
                // Do not check the currently selected line item since we don't want to associate it again with its own flights.
                if (lineItem.line_item_id == $scope.currentLineItemId) {
                    lineItem.checked = false;
                } else if (visibleLineItemIds.length == 0 ||
                    (visibleLineItemIds.length > 0 && !visibleLineItemIds.includes(lineItem.line_item_id))
                ) {
                    lineItem.checked = false;
                    $scope.allLineItemsSelected = false;
                }
            })
            // refresh dataTable
            setLineItemDataTableOptions();

            $('body').on('search.dt', function() {
                const tableFlights = $('#placementAssociations-table').DataTable();
                // traverse the visible flights and get flight id array
                let visibleFlightIds = [];
                tableFlights.rows({filter: 'applied'}).every(function () {
                    const data = this.data();
                    const flight_id = data[1];
                    visibleFlightIds.push(flight_id);
                });
                // check and uncheck flights according to visible flight id array
                _.each($scope.associations, function (association) {
                    // Do not check the currently selected line item since we don't want to associate it again with its own flights.
                    if (visibleFlightIds.length == 0 ||
                        (visibleFlightIds.length > 0 && !visibleFlightIds.includes(association.flight_id))
                    ) {
                        association.checked = false;
                        $scope.allAssociationsSelected = false;
                    }
                })
                setAssociationDataTableOptions();
            });
        });
    });

    $scope.selectAllLineItems = function(all) {
        if (all) {
            $scope.allLineItemsSelected = true;
            const table = $('#placementLineItems-table').DataTable();
            // traverse the visible lineItems and get lineItem id array
            let visibleLineItemIds = [];
            table.rows({filter: 'applied'}).every( function () {
                const data = this.data();
                const line_item_id = $(data[1]).html();
                visibleLineItemIds.push(line_item_id);
            });
            // check and uncheck lineItems according to visible lineItem id array
            // excluding current lineItem
            _.each($scope.lineItems, function (lineItem) {
                // Do not check the currently selected line item since we don't want to associate it again with its own flights.
                if (lineItem.line_item_id !== $scope.currentLineItemId &&
                    visibleLineItemIds.length > 0 &&
                    visibleLineItemIds.includes(lineItem.line_item_id)
                ) {
                    lineItem.checked = true;
                    $scope.someLineItemsSelected = true;
                } else {
                    lineItem.checked = false;
                }
            });
        } else {
            clearLineItemCheckboxes();
        }
    }

    $scope.selectedLineItem = function(lineItem) {
        if (lineItem.checked) {
            $scope.someLineItemsSelected = true;
        } else {
            $scope.allLineItemsSelected = false;
        }
        let allUnchecked = true;
        _.each($scope.lineItems, function(item) {
            if (item.checked) {
                allUnchecked = false;
            }
        });
        if (allUnchecked) {
            $scope.someLineItemsSelected = false;
        }
    }

    $scope.selectAllAssociations = function(all) {
        if (all) {
            $scope.someAssociationsSelected = true;
            $scope.allAssociationsSelected = true;
            const table = $('#placementAssociations-table').DataTable();
            // traverse the visible flights and get flight id array
            let visibleFlightIds = [];
            table.rows({filter: 'applied'}).every(function () {
                const data = this.data();
                const flight_id = data[1];
                visibleFlightIds.push(flight_id);
            });
            // check and uncheck flights according to visible flight id array
            _.each($scope.associations, function (association) {
                // Do not check the currently selected line item since we don't want to associate it again with its own flights.
                if (visibleFlightIds.length > 0 && visibleFlightIds.includes(association.flight_id)) {
                    association.checked = true;
                } else {
                    association.checked = false;
                }
            })
        } else {
            $scope.someAssociationsSelected = false;
            $scope.allAssociationsSelected = false;
            _.each($scope.associations, function (association) {
                association.checked = false;
            });
        }
    }

    $scope.selectedAssociation = function(association) {
        if (association.checked) {
            $scope.someAssociationsSelected = true;
        }
        let allUnchecked = true;
        _.each($scope.associations, function(item) {
            if (item.checked) {
                allUnchecked = false;
            }
        });
        if (allUnchecked) {
            $scope.someAssociationsSelected = false;
        }
    }

    $scope.assignPlacements = function() {
        let checkedLineItemIds = [];
        let checkedFlightIds = [];

        $scope.lineItems.forEach(function (lineItem) {
            if (lineItem.checked) {
                if ($scope.formObj.targetLineItemId !== lineItem.line_item_id) {
                    checkedLineItemIds.push(lineItem.line_item_id);
                }
            }
        });

        $scope.associations.forEach(function (association) {
            if (association.checked) {
                checkedFlightIds.push(association.flight_id);
            }
        });

        let modalInstance = $modal.open(
            ModalService.returnModalType('assignPlacements', {
                data: {
                    checkedLineItemIds: checkedLineItemIds,
                    checkedFlightIds: checkedFlightIds,
                    targetLineItemId: $scope.formObj.targetLineItemId
                }
            })
        );
        modalInstance.result.then(function () {
            $rs.loadingInProgress = true;
            if ($scope.formObj.targetLineItemId) {
                $rs.loadertitle = "Move flights operation in progress, please wait...";
                OrdersService.moveFlight(checkedFlightIds, $scope.formObj.targetLineItemId, $scope.formObj.selectedStatusId, null, $scope.formObj.selectedWorkflowAction).then(function (data) {
                    if (data.errors) {
                        if (data.errors.length === 1) {
                            console.log(data.errors[0]);
                        } else {
                            console.log(data.errors);
                        }
                        $ioAlert.show('Error!', data.errors, 'error');
                        $rs.loadingInProgress = false;
                    } else if (!data.hasOwnProperty('flight_ids')) {
                        $ioAlert.show('Error!', 'An error occurred, please contact your support representative', 'error');
                        $rs.loadingInProgress = false;
                    } else {
                        $ioAlert.show('', 'Flights moved successfully', 'success');
                        doAssignPlacements(checkedLineItemIds, checkedFlightIds);
                    }
                }, function () {
                    $ioAlert.show('Error!', 'Something went wrong here. Please refresh the page to try again.', 'error');
                    $rs.loadingInProgress = false;
                });
            } else {
                doAssignPlacements(checkedLineItemIds, checkedFlightIds);
            }
        });
    }

    const doAssignPlacements = function(checkedLineItemIds, checkedFlightIds) {
        if (checkedLineItemIds.length === 0 || checkedFlightIds.length === 0) {
            $rs.loadingInProgress = false;
            $ioAlert.show('', 'No associations to create', 'success');
            getLineItemAndAssociationData($scope.orderId, $scope.productId);
            return;
        }

        $rs.loadertitle = "Creating new line item to flight associations, please wait...";
        OrdersService.assignPlacements(checkedLineItemIds, checkedFlightIds).then(function (data) {
            $rs.loadingInProgress = false;
            if (data.errors) {
                if (data.errors.length == 1) {
                    console.log(data.errors[0]);
                } else {
                    console.log(data.errors);
                }
                $ioAlert.show('Error!', data.errors, 'error');
            } else {
                $ioAlert.show('', 'Placement operation completed successfully: ' +
                    data.numCreated + (data.numCreated < 2 ? ' association' : ' associations') + ' created', 'success');
            }
            // Reload everything now that flights and associations have been modified.
            getLineItemAndAssociationData($scope.orderId, $scope.productId);
        }, function () {
            $rs.loadingInProgress = false;
            $ioAlert.show('Error!', 'Something went wrong here. Please refresh the page to try again.', 'error');
            getLineItemAndAssociationData($scope.orderId, $scope.productId);
        });
    }

    const getFlightStatuses = function() {
        OrdersService.getFlightStatuses().then(function(data) {
            $scope.flightStatusList = data;
            $scope.flightStatusList.forEach(function(status_row) {
                if (isArchivedFlightStatusName(status_row.name)) {
                    FlightArchivedStatusIds.push(parseInt(status_row.id));
                }
            });
        }, function(error) {
            console.log("Error loading flight statuses: " + error);
        });
    }

    const getWorkflowActions = function() {
        WorkflowsService.getWorkflowActions().then(function(data) {
            $scope.workflowActions = data;
        }, function(error) {
            console.log("Error loading workflow action list: " + error);
        });
    }

    function isArchivedFlightStatusName(status_name) {
        return Object.values(FlightArchivedStatusNames).includes(status_name);
    }

    function isArchivedFlightStatusId(status_id) {
        return FlightArchivedStatusIds.includes(parseInt(status_id));
    }

    function isArchivedLineItemStatusId(status_id) {
        return LineItemArchivedStatusIds.includes(parseInt(status_id));
    }

    $scope.showOpenLineItemsAndFlights = function() {
        $scope.showAllItems = false;
        resetDataTables();
        clearFlightCheckboxes();
        clearLineItemCheckboxes();
        $scope.currentLineItemId = undefined;
        $scope.formObj.targetLineItemId = undefined;
        verifyLoadingCompleted();
    }

    $scope.showAllLineItemsAndFlights = function() {
        $scope.showAllItems = true;
        resetDataTables();
        clearFlightCheckboxes();
        clearLineItemCheckboxes();
        $scope.currentLineItemId = undefined;
        $scope.formObj.targetLineItemId = undefined;
        verifyLoadingCompleted();
    }

    const resetDataTables = function() {
        // Clear/destroy the datatables as we're rebuilding them with new data and need to be reinitialized.
        let lineItemsDatatable = $('#placementLineItems-table').DataTable();
        if (lineItemsDatatable) {
            lineItemsDatatable.clear();
            lineItemsDatatable.destroy();
        }
        resetAssociationsDataTable();
    }

    const resetAssociationsDataTable = function() {
        let associationsDatatable = $('#placementAssociations-table').DataTable();
        if (associationsDatatable) {
            associationsDatatable.clear();
            associationsDatatable.destroy();
        }
    }

    const clearLineItemCheckboxes = function() {
        $scope.someLineItemsSelected = false;
        $scope.allLineItemsSelected = false;
        _.each($scope.lineItems, function (lineItem) {
            lineItem.checked = false;
        });
    }

    $scope.backToFromPage = function() {
        if ($scope.fromPage === 'order') {
            $state.go('viewOrder', {
                id: $scope.orderId
            });
        } else if ($scope.fromPage === 'orderDetails') {
            $state.go('detailedOrders');
        } else if ($scope.fromPage === 'orders') {
            $state.go('orders');
        }
    }

    const init = function() {
        $scope.fromPage = $stateParams.fromPage;
        $scope.orderId = $stateParams.orderId;
        $scope.lineItemId = $stateParams.lineItemId;

        if (!$scope.orderId) {
            $ioAlert.show('Placement Manager', 'orderId input parameter not set', 'error');
        }

        if (!$scope.orderId) {
            return;
        }

        if ($rs.userRole.permissions != 'adops' &&
            $rs.userRole.permissions != 'adops,admin' &&
            $rs.userRole.permissions != 'superadmin') {
            // Allowed for Adops, Adops Manager and SuperAdmin user roles
            $ioAlert.show('Placement Manager', 'This page is only available to AdOps, AdOps Manager, and Super Admin users', 'error');
            return;
        }

        getOrder();
        getFlightStatuses();
    }

    init();
}
